import { Link, Navigate, useParams } from "react-router-dom";
export function RetiredPage() {
  return (
    <section>
      <h1>This page has moved</h1>
      <p>Import a packing list to find a fleet for your shipment.</p>
      <Link to="/">Go to Plans</Link>
    </section>
  );
}
export function LegacyPlanRoute({
  stage,
  importReady = false,
}: {
  stage: "cargo" | "loading";
  importReady?: boolean;
}) {
  const { id } = useParams();
  return <Navigate replace to={`/plans/${id}?tab=${stage}${importReady ? "&import=ready" : ""}`} />;
}
export function HelpPage() {
  return (
    <section>
      <h1>Plan a road shipment</h1>
      <ol>
        <li>
          <strong>Packing list:</strong> upload a file or paste cargo, review columns and units, and
          resolve missing values.
        </li>
        <li>
          <strong>Find a plan:</strong> choose lower rental cost or fewer trucks, set your stacking
          preference, and find plans. Trucks come from our rental catalog.
        </li>
        <li>
          <strong>Fleet &amp; loadout:</strong> choose a plan, explore the fleet in 3D, and open
          each truck for its loadout and packing list. Share or download the loading instructions.
        </li>
      </ol>
      <section id="axle-loads" aria-labelledby="help-axles-heading">
        <h2 id="help-axles-heading">Plan within axle limits</h2>
        <p>
          Open Settings → Axle loads from your profile menu to update each combination’s axle-group,
          kingpin and gross limits. Positions and empty support weights are under “Positions and
          empty weights”. New searches use these settings automatically; saved loadouts retain their
          captured profiles.
        </p>
        <p>
          The optimizer shifts cargo where feasible and excludes alternatives that exceed a saved
          axle limit or predict uplift. Loads include vehicle tare and kingpin transfer through the
          horse and both Superlink trailers. Axle forces in 3D show equal sharing within each axle
          group.
        </p>
        <p>
          Default road ceilings follow the common SA arrangements: 7.7 t steer, 9 t dual-wheel
          single, 18 t dual-wheel tandem, 24 t dual-wheel tri-axle and 56 t gross combination. Lower
          saved vehicle limits take precedence.
        </p>
        <p>
          Sources for default axle profiles:{" "}
          <a href="https://www.transport.gov.za/wp-content/uploads/2023/02/TRH11-8thEdition2010_Final__2.pdf">
            Department of Transport TRH11, ordinary NRTR limits
          </a>{" "}
          and{" "}
          <a href="https://www.gov.za/sites/default/files/gcis_document/201411/38142rg10303gon846.pdf">
            regulation 237 amendment, R.846 clause 55
          </a>
          .
        </p>
        <p>
          Agents can read <code>GET /api/v1/axle-profiles</code> and, with an admin’s key and your
          instruction, update profiles through <code>PATCH /api/v1/axle-profiles</code>.
          Optimization responses include calculated axle loads per truck. The{" "}
          <a href="/api/v1/docs">API guide</a> defines every field, units, coordinate origins and
          assumptions.
        </p>
      </section>
      <p>
        <Link to="/terms">Terms</Link>
      </p>
      <Link to="/">Go to Plans</Link>
    </section>
  );
}
